import { createSlice } from '@reduxjs/toolkit';
import { boolean } from 'yup';

const authenticationSlice = createSlice({
  name: 'authentication',
  initialState: {
    login: {},
    authKey: false,
  },
  reducers: {
    updatelogin: (state: any, action: any) => {
      state.login = action.payload;
    },
    updateAuthKey: (state: any, action: any) => {
      state.authKey = action.payload;
    },
    resetLogin: (state: any) => {
      state.login = {};
      state.authKey = false;
    }
  },
  extraReducers: (builder: any) => {
    // builder.addCase(fetchLogin.fulfilled, (state: any, action: any) => {
    //   state.login = action.payload;
    // });
    // builder.addCase(fetchLogin.rejected, (state: any, action: any) => {
    //   state.login = action.payload;
    //   showToast(action.error.message, 'error');
    // });
  },
});

const { reducer } = authenticationSlice;
const selectorAuthentication = (state: any) => state.authentication;
const {
  updatelogin,
  resetLogin,
  updateAuthKey,
} = authenticationSlice.actions;
export {
  updatelogin,
  resetLogin,
  updateAuthKey,
  selectorAuthentication,
};

export default reducer;
